export default "__VITE_ASSET__15304438__"